import styles from '@components/components/CmsComponents/components/CmsInstagramLinklist/CmsInstagramLinklist.module.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Content, Image, Link } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';

const CmsInstagramLinklist = ({ items }) => (
  <div
    className={classNames(styles.container, {
      [styles.containerWithFewerBlogs]: items.length <= 3,
    })}
  >
    {items?.map(({ image, link, area }) => (
      <div className={styles.linkWrapper} key={image?.src}>
        {image && (
          <Image
            alt={image.alt}
            className={styles.instagramImage}
            href={link.url}
            src={image.src}
            srcSet={image.srcSet}
            target={link.target}
          />
        )}
        {link && (
          <Link className={styles.link} target={link.target} to={link.url}>
            {link.title}
          </Link>
        )}
        {area && (
          <Content noSpacing size="md">
            {area}
          </Content>
        )}
      </div>
    ))}
  </div>
);

CmsInstagramLinklist.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.objectOf(
        PropTypes.shape({
          alt: PropTypes.string,
          src: PropTypes.string,
          srcSet: PropTypes.bool,
        }),
      ),
      link: PropTypes.objectOf(
        PropTypes.shape({
          title: PropTypes.string,
          url: PropTypes.string,
        }),
      ),
      area: PropTypes.string,
      newTab: PropTypes.bool,
    }),
  ).isRequired,
};

export default CmsInstagramLinklist;
